const env =
  typeof process !== "undefined" && process.env ? process.env : {};

export const isAuthDisabled = env.REACT_APP_DISABLE_AUTH === "true";
export const apiUrl = env.REACT_APP_API_URL || "http://localhost:4001/api";
